/**
 * Academy-related constants and common paths
 */

export const ACADEMY_PATHS = {
    // Main academy page
    HOME: '/',

    // Common course paths (extracted from existing usage)
    DISCOVERING_HONEYBOOK: '/student/page/2016318-discovering-honeybook',
    GETTING_STARTED: '/student/path/2366148/activity/3658517',
    AUTOMATIONS_COURSE: '/student/path/2432156',
    GROWTH_TOOLKIT: '/student/path/2419160',

    // Specific resource links (with sl/ shortlinks)
    AI_SETTINGS_HELP: '/sl/f338b43e',
    AUTOMATIONS_HELP: '/sl/1aea7dcd',
    AUTOMATIONS_INTRO: '/sl/1b1ff7bf',
    AUTOMATIONS_MIGRATION: '/sl/1182f5e1',
    CLIENT_PORTAL_HELP:
        '/sl/32d6a6a6?utm_initiative=clientportal2&utm_medium=education&utm_source=in-product-branding-page&utm_campaign=',
    WEBINAR_LINK: '/sl/335e3fbb',
    JUMPSTART_COURSE: '/student/path/2366148',

    // Event pages
    ALL_EVENTS: '/student/all_events'
} as const;

export const PARTNER_ACADEMY_PATHS = {
    RESOURCES: '/sl/780b5e30'
} as const;

// Type for academy path keys
export type AcademyPathKey = keyof typeof ACADEMY_PATHS;
export type PartnerAcademyPathKey = keyof typeof PARTNER_ACADEMY_PATHS;
